<details class="m-2 rounded border border-slate-300 bg-white p-3">
  <summary class="cursor-pointer font-medium">API Bearer token：{{ auth.credentials() ? '已設定' : '未設定' }}{{ auth.unauthorized() ? '（驗證失敗，請更新）' : '' }}</summary>
  <form class="mt-3 flex flex-wrap items-end gap-3" (ngSubmit)="saveToken()">
    <label class="flex min-w-64 flex-1 flex-col gap-1">API 網址
      <input class="rounded border p-2" name="apiBaseUrl" [(ngModel)]="apiBaseUrl" placeholder="https://api.example.com" required>
    </label>
    <label class="flex min-w-64 flex-1 flex-col gap-1">Bearer token
      <input class="rounded border p-2" name="apiToken" type="password" [(ngModel)]="token" autocomplete="off" spellcheck="false" placeholder="貼上 token，不含 Bearer 前綴">
    </label>
    <button class="btn-primary" type="submit" [disabled]="checking()">{{ checking() ? '驗證中…' : '儲存並驗證' }}</button>
    <button class="btn-secondary" type="button" (click)="clearToken()">清除 token</button>
  </form>
  <p class="mt-2 text-sm text-slate-600">Token 僅暫存在目前分頁，只傳送至上述 API 網址。正式環境請使用 HTTPS。此設定不會變更各功能的 API 網址。</p>
  <p class="mt-2 text-sm" aria-live="polite">{{ status() }}</p>
</details>
